import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { Paginado } from 'src/app/models/paginado';
import { DataService } from 'src/app/services/data.service';
import { NotifierService } from 'angular-notifier';
import {CdkDragDrop, moveItemInArray,CdkDropList} from '@angular/cdk/drag-drop';
import {MatTableDataSource} from '@angular/material/table';


@Component({
  selector: 'app-priorizacion-iniciativas',
  templateUrl: './priorizacion-iniciativas.component.html',
  styleUrls: ['./priorizacion-iniciativas.component.css']
})


export class PriorizacionIniciativasComponent implements OnInit {
  

  emailUser: string;
  paginado: Paginado;

  displayedColumns: string[] = ['position', 'Folio', 'Sistema', 'Tipo','Solicitante','Fecha','Estatus'];
  dataSource:any;


  constructor(private dataService: DataService,
    private authService: AuthService,
    private notifier: NotifierService) { }

  ngOnInit(): void {

    this.authService.user.subscribe((user: string) => {
      {this.emailUser = user}
      //return this.emailUser;

        this.paginado = new Paginado();
        this.paginado.numeroPagina = 1;
        this.paginado.email=this.emailUser;
        this.paginado.fechaInicio="";
        this.paginado.fechaFin="";
        this.paginado.termino="";
        //Cargamos las iniciativas 
        this.verDetallesIniciativa(this.paginado);
    });
  }

  verDetallesIniciativa(paginado:Paginado) 
  {
    this.dataService.obtenerIniciativasPriorizacion(paginado.email,paginado.rolUserlogin).subscribe(
      data => {
        this.dataSource = new MatTableDataSource(data['data']) ;
        //this.dataSource = data['data'];
      },
      error => {
        console.error(error);
        this.notifier.notify(
          'error',
          'Error al intentar obtener la información de la iniciativa. Verifica tu conexión de red.'
        );
      }
    );
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.dataSource, event.previousIndex, event.currentIndex);
  }

}//Cierre de clase
